import { OutputBlockData, OutputData } from "@editorjs/editorjs";
import edjsHTML from "editorjs-html";

function customParser(block: OutputBlockData) {
  return `<div> ${block.data.text}</div>`;
}

function videoParser(block: OutputBlockData) {
  const url = block.data.url || block.data.file?.url;
  return `<video class="block" controls src="${url}" />`
}

function delimiterParser(block: OutputBlockData) {
  return `<br />`
}

export function tableParser(block: OutputBlockData) {
  const { content, withHeadings, stretched } = block.data as any;
  
  if (!content || !Array.isArray(content)) {
    return '<div class="table-error">Invalid table data</div>';
  }

  let tableHtml = '<div class="table-wrapper table-auto">';
  
  if (stretched) {
    tableHtml += '<div class="table-stretched">';
  }
  
  tableHtml += '<table class="editorjs-table">';
  
  // Add table body
  tableHtml += '<tbody>';
  
  content.forEach((row: string[], rowIndex: number) => {
    tableHtml += '<tr>';
    
    row.forEach((cell: string, cellIndex: number) => {
      // First row as header if withHeadings is true
      if (withHeadings && rowIndex === 0) {
        tableHtml += `<th class="table-cell table-header">${cell || '&nbsp;'}</th>`;
      } else {
        tableHtml += `<td class="table-cell">${cell || '&nbsp;'}</td>`;
      }
    });
    
    tableHtml += '</tr>';
  });
  
  tableHtml += '</tbody>';
  tableHtml += '</table>';
  
  if (stretched) {
    tableHtml += '</div>';
  }
  
  tableHtml += '</div>';
  
  return tableHtml;
}

const edjsParser = edjsHTML({
  paragraph: customParser,
  video: videoParser,
  table: tableParser,
});

export const getHtmlFromBlocks = (data: OutputData) => {
    const html = edjsParser.parse(data);
    return html;
}